import { render, staticRenderFns } from "./AwardList.vue?vue&type=template&id=156ea8ee&scoped=true"
import script from "./AwardList.vue?vue&type=script&lang=js"
export * from "./AwardList.vue?vue&type=script&lang=js"
import style0 from "./AwardList.vue?vue&type=style&index=0&id=156ea8ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156ea8ee",
  null
  
)

export default component.exports